import React, { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { MLTestDocument } from '../../admin/ai/playground/store';
import { ArkOpinion } from '../../opinions/my-opinions/store';
import { ArkDocument, LinkedDocument } from '../../documents/store/types';
import styles from './DocumentViewer.module.scss';
import { PDFViewer, ReactPdf } from './PDFViewer';
import { DocumentViewerType, getNumberOfPages, setDocumentViewerType, setNumberOfPages } from './store';
import { MLFewShotDocument } from '../../admin/ai/few-shot/store';
import { MimeType } from '../../constants/MimeType';

interface DocumentViewerProps {
    url: string;
    selectedDocument: ArkDocument | ArkOpinion | LinkedDocument | MLTestDocument | MLFewShotDocument;
    width: number;
    selectedPage?: number | null;
    showScheduleStartPage?: boolean;
    setSelectedPage?: (page: number | null) => void;
    scheduleStartPage?: number;
    isSupportDocument: boolean;
    type: DocumentViewerType;
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({ url, selectedDocument, width, selectedPage, showScheduleStartPage, setSelectedPage, scheduleStartPage, isSupportDocument, type }) => {
    const dispatch = useAppDispatch();
    const numberOfPages = useAppSelector(getNumberOfPages);
    const setNumPages = useCallback((numPages: number | null) => dispatch(setNumberOfPages(numPages)), [dispatch]);

    const onLoadSuccess = useCallback(({ numPages }: ReactPdf) => setNumPages(numPages), [setNumPages]);

    useEffect(() => {
        dispatch(setDocumentViewerType(type));
        return () => {
            dispatch(setDocumentViewerType(null));
        };
    }, [dispatch, type]);

    if (selectedDocument.mimeType === MimeType.PDF) {
        return (
            <div className={styles.pdfViewerWrapper}>
                <PDFViewer
                    onLoadSuccess={onLoadSuccess}
                    resetNumPages={() => setNumPages(null)}
                    numPages={numberOfPages}
                    pdfUrl={url}
                    width={width}
                    selectedPage={selectedPage}
                    showScheduleStartPage={showScheduleStartPage}
                    setSelectedPage={setSelectedPage}
                    scheduleStartPage={scheduleStartPage}
                    isSupportDocument={isSupportDocument}
                />
            </div>
        );
    }

    return null;
};
